import { Currency } from "./common.model";

export interface RequestedPayouts {
  [key: string]: number;
}

export enum AffiliateContractStatus {
  CONTRACT_PENDING = "CONTRACT_PENDING",
  NOT_SIGNED_UP = "NOT_SIGNED_UP",
  SIGNED_UP = "SIGNED_UP",
  GRACE_PERIOD = "GRACE_PERIOD",
  GRACE_PERIOD_CONTRACT_PENDING = "GRACE_PERIOD_CONTRACT_PENDING",
  GRACE_PERIOD_EXPIRED = "GRACE_PERIOD_EXPIRED",
}

export type AffiliatePayoutHistoryStatus = "OPEN" | "PROCESSED" | "CANCELLED";

export type AffiliatePayoutHistoryMethod = "WISE" | "CRYPTO_USDC" | "CRYPTO_USDT" | "BANK_TRANSFER";

export interface AffiliateData {
  affiliateId: string;
  signedUpUsersCount: number;
  commissionsCount: number;
  totalCommission: number;
  totalSales: number;
  payedOutCommission: number;
  openRequestedPayoutsSum: number;
  currency: Currency;
  openRequestedPayouts: RequestedPayouts;
}

export type AffiliateStatisticsData = {
  totalPaid: number;
  availableForWithdrawal: number;
  currentMonthCommission: number;
  totalCommission: number;
  totalCommissionLast30Days: number;
  totalCommissionPrevious30Days: number;
  totalChallengesSold: number;
  totalChallengesSoldLast30Days: number;
  totalChallengesSoldPrevious30Days: number;
  totalLinkClicks: number;
  totalLinkClicksLast30Days: number;
  totalLinkClicksPrevious30Days: number;
  totalSalesThroughLinks: number;
  totalSalesThroughLinksLast30Days: number;
  totalSalesThroughLinksPrevious30Days: number;
  currency: string;
};

export interface NewAffiliateData {
  affiliateContractStatus: AffiliateContractStatus;
  commissionConfigDetails: CommissionConfigDetails;
  affiliateName: string;
}

export enum AffiliateTierLevel {
  BRONZE = "bronze",
  SILVER = "silver",
  GOLD = "gold",
  CUSTOM_TIER = "custom",
  FIXED = "fixed",
}

export type AffiliateTier = {
  tier: number;
  percentage: number;
  target: number;
};

export type AffiliateStatistic = {
  name: string;
  total: number | string;
  value: number | string;
  difference: number;
};

type ContactPreference = "WHATSAPP" | "TELEGRAM";

export interface AffiliateRegistrationData {
  firstName: string;
  lastName: string;
  email: string;
  companyName?: string;
  website?: string;
  instagram?: string;
  twitterX?: string;
  phoneNumber?: string;
  promotionPlans?: string; // max 1000 characters
  contactPreference: ContactPreference;
  telegramId?: string; // required if contactPreference is TELEGRAM
}

export enum CommissionType {
  FIXED = "FIXED",
  STANDARD_TIER = "STANDARD_TIER",
  CUSTOM_TIER = "CUSTOM_TIER",
}

export interface CommissionConfig {
  currentTier: number;
  availableTiers: AffiliateTier[];
}

export type CommissionConfigDetails = {
  type: CommissionType;
  fixedCommissionPercentage?: number;
  tierConfig: CommissionConfig;
};

export type AffiliateReferralHistory = {
  orderId: string;
  userId: string;
  date: number;
  discountCode: string;
  commissionAmount: number;
  orderAmount: number;
  accountSize: number;
  source: string;
};

export type AffiliatePayoutHistoryItem = {
  id: string;
  date: number;
  amount: number;
  status: AffiliatePayoutHistoryStatus;
  method: AffiliatePayoutHistoryMethod;
};

export type PageInfo = {
  currentPage: number;
  size: number;
  first: boolean;
  last: boolean;
  totalPages: number;
};

export type AffiliateReferralHistoryResponse = {
  items: AffiliateReferralHistory[];
  totalItems: number;
  pageInfo: PageInfo;
};

export type AffiliatePayoutHistoryResponse = {
  items: AffiliatePayoutHistoryItem[];
  totalItems: number;
  pageInfo: PageInfo;
};

export type OrderStatus = "OPEN" | "PROCESSED" | "CANCELLED";
